import React,{useState,useEffect} from "react";
import styles from "../ModernDayLearning/ModernDayLearning.module.scss";
import ModernDayLearningImgBannerWeb from "../../../assets/images/ModernDayLearningImgBannerWeb.png";
import ModernDayLearningMob from '../../../assets/images/ModernDayLearningMob.png'

const ModernDayLearning: React.FC = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth < 992);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
    
 
  return (
    <div id="career-guidence" className={styles.careerDuide}>
      <div className="container-fluid">
        <div className="section">
          {/* <div className="row">
            <div className="col-12">
              <p className="heading">Introducing new technologies in modern-day learning</p>
            </div>
          </div> */}
          {/* <div className={`row position-relative ${styles.GuidelineMobView}`}>
            <div
              className={`col-lg-4 col-md-12 col-sm-12 ${styles.partnerImageDiv}`}
            >
              <img
                src={isMobile ? ModernDayLearningMob : ModernDayLearningImgBanner}
                alt="AptechImage"
                className={`${styles.partnerImage} img-fluid`}
              />
            </div>

            <div className="col-lg-8 col-md-12 col-sm-12 d-flex justify-content-start align-items-center">
              <div
                className={`d-flex flex-column justify-content-center w-100 ${styles.careerGuidenceContent}`}
              >
                <p className="para">
                With time, Aptech is integrating cutting-edge technologies into its educational offerings, enhancing learning experience through innovative tools and methodologies.
                </p>

               <p className="para pt-4"><strong>Integration of AR VR technologies, combining generative AI with human expertise</strong>, and introduction of <strong>Onlinevarsity</strong>, Aptech's learning app that provides free access to study materials from anywhere, <strong>virtual production units, and Creval, a generative AI-powered tool that provides specific and comprehensive feedback and actionable insights</strong></p>
              <p className="para">are some of the cutting-edge technologies introduced by the company.</p>
              </div>
            </div>
          </div> */}
          {!isMobile ? (

<div className={styles.GuidelineMobView}>
  <div className="container">
          <div className={`row`}>
            <div className="col-lg-8 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
              <div className={styles.columnPara}>
            <p className="heading">Introducing new technologies in modern-day learning</p>
            <p className="para">
                With time, Aptech is integrating cutting-edge technologies into its educational offerings, enhancing learning experience through innovative tools and methodologies.
                </p>

               <p className={`para ${isMobile ? 'pt-0' : 'pt-4'}`}><strong>Integration of AR VR technologies, combining generative AI with human expertise</strong>, and introduction of <strong>Onlinevarsity</strong>, Aptech's learning app that provides free access to study materials from anywhere, <strong>virtual production units, and Creval, a generative AI-powered tool that provides specific and comprehensive feedback and actionable insights</strong> are some of the cutting-edge technologies introduced by the company.</p>
</div>


            </div>
            <div className="col-lg-4 col-md-12 col-sm-12">
            <img
                src={isMobile ? ModernDayLearningMob : ModernDayLearningImgBannerWeb}
                alt="AptechImage"
                className={`${styles.partnerImage} img-fluid`}
              />

            </div>

          </div>
          </div>
          </div>
          ):(
            <div className={styles.GuidelineMobView}>
                          <p className="heading">Introducing new technologies in modern-day learning</p>

          <div className={`row d-flex flex-column-reverse`}>
            <div className="col-lg-8 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
              <div className={styles.columnPara}>
            <p className="para">
                With time, Aptech is integrating cutting-edge technologies into its educational offerings, enhancing learning experience through innovative tools and methodologies.
                </p>

               <p className={`para ${isMobile ? 'pt-0' : 'pt-4'}`}><strong>Integration of AR VR technologies, combining generative AI with human expertise</strong>, and introduction of <strong>Onlinevarsity</strong>, Aptech's learning app that provides free access to study materials from anywhere, <strong>virtual production units, and Creval, a generative AI-powered tool that provides specific and comprehensive feedback and actionable insights</strong> are some of the cutting-edge technologies introduced by the company.</p>
</div>


            </div>
            <div className="col-lg-4 col-md-12 col-sm-12">
            <img
                src={isMobile ? ModernDayLearningMob : ModernDayLearningImgBannerWeb}
                alt="AptechImage"
                className={`${styles.partnerImage} img-fluid`}
              />

            </div>

          </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ModernDayLearning;
